<template>
  <div class="fullheight" style="padding-top: 16px; height: calc(100% - 16px)">
    <eco-table
      ref="waterMarkTable"
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="watermark_name"
      :show-export="false"
      :defaultSorter="[{ property: 'CREATE_TIME_', direction: 'DESC' }]"
    >
      <template v-slot:toolbar>
        <el-button type="primary" size="small" @click="handleCommand({ command: 'add' })">添加</el-button>
        <fe-delete-button :url="waterMarkDeleteUrl" class="marginLeft16" :htTable="$refs.waterMarkTable">删除</fe-delete-button>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="watermark_name" label="名称" width="400" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <el-link @click="handleCommand({ row: row, command: 'edit' })" type="primary">
              {{ row.watermark_name }}
            </el-link>
          </template>
        </eco-table-column>
        <eco-table-column
          prop="status"
          label="水印状态"
          :filters="[
            { text: '启用', value: '1' },
            { text: '禁用', value: '0' }
          ]"
        >
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.status === '1'">启用</el-tag>
            <el-tag type="danger" v-if="row.status === '0'">禁用</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column width="300" label="操作">
          <template v-slot="{ row }">
            <el-link type="primary" :underline="false" @click="handleCommand({ row: row, command: 'edit' })">编辑</el-link>
            <el-link type="primary" :underline="false" v-if="row.status === '1'" @click="config(row.id)" class="marginLeft16">应用配置</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <el-dialog width="50%" :title="identiyTitle" :visible="dialogVisible" :before-close="handleClose">
      <el-form :disabled="waterMarkDisabled" v-model="waterMark" data-vv-scope="editwaterMarkForm">
        <eco-form-item label="水印名称" prop="name" label-width="120px" class="waterMark-input-width">
          <eco-input v-model="waterMark.watermark_name" autocomplete="off" :validate="{ required: true, max: 50 }" placeholder="请输入名称"></eco-input>
        </eco-form-item>
        <eco-form-item label="字体大小" label-width="120px" class="waterMark-input-width">
          <eco-select
            width="100%"
            v-model="waterMark.watermark_fontsize"
            :options="[
              { key: 10, value: '10' },
              { key: 11, value: '11' },
              { key: 12, value: '12' },
              { key: 14, value: '14' },
              { key: 16, value: '16' },
              { key: 18, value: '18' },
              { key: 20, value: '20' },
              { key: 22, value: '22' },
              { key: 26, value: '26' },
              { key: 28, value: '28' },
              { key: 30, value: '30' }
            ]"
            :validate="{ required: true }"
            placeholder="请输入字体大小"
          />
        </eco-form-item>
        <eco-form-item label="字体颜色" label-width="120px" class="waterMark-input-width">
          <el-color-picker width="100%" v-model="waterMark.watermark_color" :validate="{ required: true }"> </el-color-picker>
        </eco-form-item>
        <eco-form-item label="不透明度(%)" label-width="120px" class="waterMark-input-width">
          <eco-input
            width="20%"
            type="number"
            :min="0"
            :max="100"
            v-model="waterMark.watermark_alpha"
            :validate="{ required: true }"
            placeholder="请输入不透明度"
          />
        </eco-form-item>
        <eco-form-item label="倾斜45°" label-width="120px" class="waterMark-input-width">
          <eco-radio :validate="{ required: true }" v-model="waterMark.watermark_angle" :options="angleTypes" />
        </eco-form-item>
        <eco-form-item label="文字内容" label-width="120px" class="waterMark-input-width">
          <el-row>
            <el-col :span="20">
              <eco-input type="textarea" :rows="50" :validate="{ required: true }" v-model="waterMark.watermark_txt" placeholder="请输入文字内容" />
            </el-col>
            <el-col :span="4" style="padding-left: 10px">
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link"> 设置<i class="el-icon-arrow-down el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="{
                      command: 'setWaterMarkTxtTmp',
                      value: '{当前操作者姓名:currentUserName}'
                    }"
                    >当前操作者姓名</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      command: 'setWaterMarkTxtTmp',
                      value: '{当前操作者工号:currentUserNo}'
                    }"
                    >当前操作者工号</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      command: 'setWaterMarkTxtTmp',
                      value: '{当前操作者手机:currentUserMobile}'
                    }"
                    >当前操作者手机</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      command: 'setWaterMarkTxtTmp',
                      value: '{当前操作者部门:currentUserDept}'
                    }"
                    >当前操作者部门</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      command: 'setWaterMarkTxtTmp',
                      value: '{当前操作者公司:currentUserCompany}'
                    }"
                    >当前操作者公司</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="{
                      command: 'setWaterMarkTxtTmp',
                      value: '{当前时间:currentDatetime}'
                    }"
                    >当前时间</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </eco-form-item>
        <eco-form-item label="水印状态" label-width="120px" class="waterMark-input-width">
          <eco-radio :validate="{ required: true }" v-model="waterMark.status" :options="statusTypes" />
        </eco-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          v-show="!waterMarkDisabled"
          :url="savewaterMarkUrl()"
          :model="waterMark"
          :is-submit="isSubmit"
          :request-method="requestMethod"
          scope-name="editwaterMarkForm"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <el-button @click="dialogCancle('dialogVisible')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 加载数据 用作编辑水印和查看水印-->
    <fe-load-data :url="loadDataUrl" context="portal" @after-load-data="afterLoadData"></fe-load-data>

    <EipFormDialog ref="eipFormDialog" :single="false" :value="['joint_deduction']" @onConfirm="dialogConfirm" appendToBody />
  </div>
</template>
<script>
import portal from '@/api/portal.js'
import EcoRealtimeTextarea from '@/components/eipControl/EipRealtimeTextarea.vue'
import EipFormDialog from '@/components/dialog/EipFormDialog.vue'
import FlowVarSelector from '@/components/flow/FlowVarSelector.vue'
export default {
  name: 'meta-waterMark',
  components: { FlowVarSelector, EipFormDialog, EcoRealtimeTextarea },
  data() {
    return {
      waterMarkDisabled: false,
      identiyTitle: '',
      loadDataUrl: '',
      dialogVisible: false,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      isSubmit: true,
      waterMark: {
        watermark_name: '',
        watermark_fontsize: 14,
        watermark_color: '#000000',
        watermark_alpha: '100',
        watermark_angle: '45',
        watermark_txt: '',
        status: ''
      },
      angleTypes: [
        { key: '45', value: '是' },
        { key: '0', value: '否' }
      ],
      statusTypes: [
        { key: '1', value: '启用' },
        { key: '0', value: '禁用' }
      ],
      configSettingId: ''
    }
  },
  computed: {
    requestMethod: function () {
      return this.configSettingId ? 'PUT' : 'POST'
    },
    waterMarkDeleteUrl: function () {
      return window.context.portal + '/watermark/setting/'
    }
  },
  methods: {
    beforeSaveData() {
      this.isSubmit = true
    },
    savewaterMarkUrl: function () {
      return window.context.portal + '/watermark/setting/'
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.waterMarkTable.load()
    },
    afterLoadData(data) {
      // 编辑水印
      if (this.dialogVisible) {
        this.waterMark = data
        setTimeout(() => this.$validator.validateAll('editwaterMarkForm'))
      }
    },
    dialogCancle(dialogVisible) {
      this.loadDataUrl = ''
      this[dialogVisible] = false
      setTimeout(() => (this.waterMarkDisabled = false), 500)
    },
    handleClose() {
      this.loadDataUrl = ''
      this.dialogVisible = false
      setTimeout(() => (this.waterMarkDisabled = false), 500)
    },
    showDialog(row) {
      this.dialogVisible = true
      if (row) {
        this.configSettingId = row.id
        this.loadDataUrl = `/watermark/setting/${row.id}`
      }
    },
    handleNodeClick(node) {},
    loadData(param, cb) {
      portal
        .getWaterMarkAll(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          this.identiyTitle = '编辑水印'
          this.showDialog(params.row)
          break
        case 'add':
          this.configSettingId = ''
          this.waterMark = {
            watermark_name: '',
            watermark_fontsize: 14,
            watermark_color: '#000000',
            watermark_alpha: '100',
            watermark_angle: '45',
            watermark_txt: ''
          }
          this.identiyTitle = '添加水印'
          this.showDialog()
          break
        case 'get':
          this.identiyTitle = '查看水印'
          this.isSubmit = false
          this.waterMarkDisabled = true
          this.showDialog(params.row)
          break
        case 'setWaterMarkTxtTmp':
          this.waterMark.watermark_txt = this.waterMark.watermark_txt + params.value
          break
        default:
          break
      }
    },
    dialogConfirm(data) {
      let watermarkForms = []
      data.forEach((form) => {
        watermarkForms.push({
          watermark_id: this.configSettingId,
          form_key: form.formKey,
          form_id: form.id,
          form_name: form.name
        })
      })
      let param = {
        id: this.configSettingId,
        watermark_forms: watermarkForms
      }
      portal.saveWaterMarkForm(param, '').then((response) => {
        if (response.state) {
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
      })
    },
    config(id) {
      this.configSettingId = id
      portal.getWaterMarkForms(id).then((response) => {
        let formDialogValues = []
        response.forEach((form) => {
          formDialogValues.push({
            id: form.form_id,
            name: form.form_name,
            formKey: form.form_key
          })
        })

        this.$refs.eipFormDialog.showDialog(formDialogValues)
      })
    }
  }
}
</script>
<style scoped>
ul {
  padding: 0px;
  margin: 0px;
}

li {
  list-style-type: none;
}

.waterMark-item-bottom {
  margin-bottom: 5px;
}

.waterMark-input-width .inputs {
  width: 100%;
}
</style>
